import { useMutation, useRequest } from "../../utils/api"
import { GeneralProps, PaginationProps, ShortMutationConfigType } from "../../utils/api.type"
import { CreateBindMapProps, GetBindMapResponseType, ListBindMapResponseType, UnbindMapProps } from "./bind-map.type"

const ENDPOINT_LIST_MAP = '/v1/rms/config/bind-map/'
export const useListConfigBindMap = (obj = {} as GeneralProps & PaginationProps & {
  search?: string,
  building_uuid?: string
}) => {
  return useRequest<ListBindMapResponseType>(ENDPOINT_LIST_MAP, {
    ...obj,
    page_size: obj.page_size || 5,
    page: obj.page || 1,
    search: obj.search,
    building_uuid: obj.building_uuid || undefined,
  }, {
    enabled: obj.enabled,
    cacheKey: JSON.stringify(obj),
  })
}

const ENDPOINT_GET_BIND_MAP = '/v1/rms/config/bind-map/get-by-uuid/'
export const useGetConfigBindMap = (obj = {} as GeneralProps & { layout_uuids: string[], robot_uuids: string[] }) => {
  return useRequest<GetBindMapResponseType>(ENDPOINT_GET_BIND_MAP, {
    // ...obj,
    layout_map_uuids: (obj.layout_uuids || []).join(','),
    robot_map_uuids: (obj.robot_uuids || []).join(','),
  }, {
    enabled: obj.enabled,
    cacheKey: JSON.stringify(obj),
  })
}

const ENDPOINT_CREATE_BIND_MAP = '/v1/rms/config/bind-map/store/'
export const useCreateBindMapMutation = (options: ShortMutationConfigType) => {
  return useMutation<any, CreateBindMapProps>(ENDPOINT_CREATE_BIND_MAP, {
    ...options,
    // headers: { 'Content-Type': 'multipart/form-data' }
  })
}

const ENDPOINT_DELETE_BIND_MAP = '/v1/rms/config/bind-map/unbind/'
export const useUnbindMapMutation = (options: ShortMutationConfigType) => {
  return useMutation<any, UnbindMapProps>(ENDPOINT_DELETE_BIND_MAP, {
    ...options,
    // headers: { 'Content-Type': 'multipart/form-data' }
  })
}